<template>
    <div class="content-partnersother">
        <section class="content-partnersother-toback container">
            <div class="togoback">
                <div class="content-brand w-100 mb-0">
                    <GoToBackButton />
                    <div class="content-brand-elements d-none d-lg-block">
                        <router-link tag="a" :to="{ name: 'Home' }" class="content-brand-elements-links">
                            {{ $t('pages.goToBackButton.start') }}
                        </router-link>
                        <span> > </span>
                        <router-link tag="a" :to="{
                            name: 'Partners',
                            params: { slug: partnerCategory.slug }
                        }" class="content-brand-elements-links">
                            {{ partnerCategory.name }}
                        </router-link>
                        <span> > </span>
                        <router-link tag="a" :to="{
                            name: 'PartnerLandingPage',
                            params: { slug: businessPartner.slug }
                        }" class="content-brand-elements-links">
                            {{ businessPartner.name }}
                        </router-link>
                        <span> > </span>
                        <router-link tag="a" :to="{ name: 'PartnersOther' }" class="content-brand-elements-links">
                            {{ partnerOtherData.title }}
                        </router-link>
                    </div>
                </div>
            </div>
            <template class="socialMedia">
                <SocialSharing />
            </template>
        </section>

        <section class="content-partnersother-banner">
            <section class="" v-if="Object.keys(sectionOne).length > 0">
                <PartnersSectionFour :text="sectionOne" />
            </section>
            <section class="content-widget" v-if="Object.keys(sectionThree).length > 0">
                <PartnersSectionTwo :sectionData="sectionThree" />
            </section>
            <section class="" v-if="Object.keys(sectionFour).length > 0">
                <PartnersSectionThree :sectionData="sectionFour" />
            </section>
            <section class="" v-if="Object.keys(sectionTwo).length > 0">
                <PartnersSectionOne :text="sectionTwo" />
            </section>
        </section>
    </div>
</template>
<script>
import axios from "axios";
import GoToBackButton from "@/components/goToBackButton/GoToBackButton.vue";
import PartnersSectionOne from "@/views/Businesspartners/components/PartnersSectionOne.vue";
import PartnersSectionTwo from "@/views/Businesspartners/components/PartnersSectionTwo.vue";
import PartnersSectionThree from "@/views/Businesspartners/components/PartnersSectionThree.vue";
import PartnersSectionFour from "@/views/Businesspartners/components/PartnersSectionFour.vue";
import SocialSharing from "@/components/socialSharing/SocialSharing.vue";
export default {
    components: {
        GoToBackButton,
        PartnersSectionOne,
        PartnersSectionTwo,
        PartnersSectionThree,
        PartnersSectionFour,
        SocialSharing,
    },
    data() {
        return {
            token: "",
            partnerOther: [],
            sectionOne: [],
            sectionTwo: [],
            sectionThree: [],
            sectionFour: [],
            partnerCategory: [],
            businessPartner: [],
            partnerOtherData: [],
        };
    },
    mounted() {
        this.token = this.$route.params.token
        axios.post("/api/v1/partner/secondpage", { token: this.token })
            .then((response) => {
                this.partnerCategory = response.data.category;
                this.businessPartner = response.data.secondPageData.product;
                this.partnerOtherData = response.data.secondPageData;
                console.log("partnerCategory", this.partnerCategory);
                if (response && response.data) {
                    this.partnerOther = response.data.sections;
                    // map partnerOther to sectionData
                    this.partnerOther = Object.keys(this.partnerOther).map((key) => {
                        return this.partnerOther[key];
                    });
                    this.partnerOther.map((sectionData) => {
                        if (sectionData.form_type == 0) {
                            this.sectionOne = sectionData;
                            console.log("sectionOne", this.sectionOne);
                        }
                        if (sectionData.form_type == 1) {
                            this.sectionTwo = sectionData;
                            console.log("sectionTwo", this.sectionTwo);
                        }
                        if (sectionData.form_type == 2) {
                            this.sectionThree = sectionData;
                            console.log("sectionThree", this.sectionThree);
                        }
                        if (sectionData.form_type == 3) {
                            this.sectionFour = sectionData;
                            console.log("sectionFour", this.sectionFour);
                        }
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    },
};
</script>
<style lang="scss" scoped>
.content-partnersother {
    margin-top: calc(var(--marginHeight) + 5rem);

    @media (max-width: 991px) {
        margin-top: 8rem;
        padding: 0;
    }

    &-toback {
        margin-bottom: 3rem;

        >.content-socialsharing {
            margin-top: 5rem;
            justify-content: flex-end;
        }
    }

    &-banner {
        >.content-widget {
            margin-top: 8rem;
        }
    }
}
</style>
